import { Alert } from 'antd';
import React from 'react';

/**
 * Shared style for the explanatory notes on Platform tabs and cards, so the icon,
 * title weight, and spacing are identical everywhere.
 */
function TabNote({
  title, children, type = 'info', style,
}) {
  return (
    <Alert
      type={type}
      showIcon
      message={title}
      description={children}
      style={style}
    />
  );
}

export default TabNote;
